import { authHeader } from '../../_helpers';
import axios from 'axios';

export const AnalyseService = {
    getAssessorGroupsHandler,
    get_team_member_id_api
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')

function getAssessorGroupsHandler(data) {
    return axios.post(`/analytics/team/assessor_group/list/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function get_team_member_id_api(data) {
    return axios.post(`/analytics/participant/list/based/on/assessor/group/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}




// WEBPACK FOOTER //
// ./src/_services/Analyse/analyse.service.js